import { IRequester, requester } from "src/libraries/requester";
import { IResponse } from "src/libraries/requester/IRequester/IResponse";
import { ILinks, links } from "src/Links";
import { IMagazineCategory } from "./IMagazineCategory";
import { GetMagazineCategoriesDto } from "./dto/list-categories-dto";
import { CreateMagazineCategoryDto } from "./dto/create-category-dto";
import { UpdateMagazineCategoryDto } from "./dto/update-category-dto";

class MagazineCategoryService {
    constructor(
        private requester: IRequester,
        private links: ILinks,
    ) { }

    create = async (body: any): Promise<IResponse<any>> => {
        try {
            const response = await this.requester.post(this.links.magazineCategory, body);
            return response;
        } catch (error) {
            console.warn('MagazineCategoryService -> create: ', this.links.magazineCategory, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    list = async (body?: GetMagazineCategoriesDto): Promise<IResponse<any>> => {
        try {
            const url = new URL(this.links.magazineCategory);
            if (body) {
                Object.keys(body).forEach(key => url.searchParams.append(key, body[key]));
            }
            const response = await this.requester.get(url.href);
            return response;
        } catch (error) {
            console.warn('MagazineCategoryService -> list: ', this.links.magazineCategory, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    update = async (id: number, body: any) => {
        try {
            const url = this.links.magazineCategory + '/' + id;
            const response = await this.requester.patch(url, body);
            return response;
        } catch (error) {
            console.warn('MagazineCategoryService -> update: ', this.links.magazineCategory, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    get = async (id: number | string): Promise<IResponse<IMagazineCategory>> => {
        try {
            const response = await this.requester.get(this.links.magazineCategory + '/' + id);
            return response;
        } catch (error) {
            console.warn('MagazineCategoryService -> get: ', this.links.magazineCategory, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    delete = async (id: number): Promise<IResponse<any>> => {
        try {
            const response = await this.requester.delete(this.links.magazineCategory + `/${id}`);
            return response;
        } catch (error) {
            console.warn('MagazineCategoryService -> delete: ', this.links.magazineCategory, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }
}

export const magazineCategoryService = new MagazineCategoryService(requester, links);
